import { render, staticRenderFns } from "./Other.vue?vue&type=template&id=0d47ad62&scoped=true"
import script from "./Other.vue?vue&type=script&lang=ts"
export * from "./Other.vue?vue&type=script&lang=ts"
import style0 from "./Other.vue?vue&type=style&index=0&id=0d47ad62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d47ad62",
  null
  
)

export default component.exports